var map = {
	"./en-au": 5,
	"./en-au.js": 5,
	"./en-ca": 6,
	"./en-ca.js": 6,
	"./en-gb": 7,
	"./en-gb.js": 7,
	"./en-ie": 8,
	"./en-ie.js": 8,
	"./en-il": 9,
	"./en-il.js": 9,
	"./en-nz": 10,
	"./en-nz.js": 10
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63;


//////////////////
// WEBPACK FOOTER
// ./~/moment/locale en
// module id = 63
// module chunks = 0